import { useLocation } from 'react-router-dom';

function useIsAdmin() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/markets');
  return isAdmin;
}

export default useIsAdmin;
